<template>
    <!--
          作者：bbc_team
          时间：2023-06-08
          描述：统计-销售统计-商品统计
      -->
    <div class="sales-goods-box mt30">
        <div class="common-form">商品统计</div>
        <div class="d-s-stretch bd-box">
            <div class="d-s-c d-c left-box">
                <!--汇总-->
                <Total></Total>

                <!--已付款商品-->
                <LineChart></LineChart>
            </div>
            <!--商品排行榜-->
            <Ranking></Ranking>
        </div>
    </div>
</template>

<script>
    import Total from "./goods/Total.vue";
    import LineChart from "./goods/LineChart.vue";
    import Ranking from "./goods/Ranking.vue";
    export default {
        components: {
            Total,
            LineChart,
            Ranking
        }
    };
</script>

<style>
    .sales-goods-box .bd-box {
        border-top: 1px solid #eeeeee;
    }
    .sales-goods-box .left-box {
        width: 69%;
        border-right: 1px solid #eeeeee;
    }
</style>



// WEBPACK FOOTER //
// src/views/statistics/sales/part/Goods.vue